<template>
	<div id="app">
		<!-- <keep-alive>
		      <router-view v-if="$route.meta.keepAlive"></router-view>
		    </keep-alive>
		    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
		<router-view></router-view>
	</div>
</template>
<script>
	import qs from "qs";
	import md5 from 'blueimp-md5'
	import store from './store/index.js'
	export default {

		name: 'app',
		components: {},
		data() {
			return {
				isRouterAlive: true
			}
		},
		created() {
			this.browserRedirect();
			let that = this;
			if(that.$storage.get('user_data') != null) {
				
			} else {
				
			}

		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(() => (this.isRouterAlive = true))
			},
			
			browserRedirect() {
				//判断是PC端的浏览器还是移动端的浏览器
				let sUserAgent = navigator.userAgent.toLowerCase();
				let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
				let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
				let bIsMidp = sUserAgent.match(/midp/i) == "midp";
				let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
				let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
				let bIsAndroid = sUserAgent.match(/android/i) == "android";
				let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
				let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
				if(
					bIsIpad ||
					bIsIphoneOs ||
					bIsMidp ||
					bIsUc7 ||
					bIsUc ||
					bIsAndroid ||
					bIsCE ||
					bIsWM
				) {
					window.location.href = "https://h5.51wenju.com/";
				}
			},
		}

	}
</script>

<style>
	@import url("assets/font.css");
</style>